import { createAsyncThunk } from '@reduxjs/toolkit';
import { downTimeAPI } from './downTimeAPI';

export const getCPCBLog = createAsyncThunk('downTime/getCPCBLog', async () => {
  const response = await downTimeAPI.getCPCBLog();
  return response.data;
});
